import api from "../api";
import type { ApiResponse, Hotel } from "@/types";

export const hotelApi = {
    create: (params?: any) => api.post('admin/hotels', params),

    getAll: () => api.get<ApiResponse<Hotel[]>>("admin/hotels"),

    getAllPublic: () => api.get<ApiResponse<Hotel[]>>("hotels"),

    show: (id: number) => api.get<ApiResponse<Hotel>>(`hotels/${id}`),

    update: (id: number, params?: any) => api.post(`admin/hotels/${id}`, params),

    delete: (id: number) => api.delete(`admin/hotels/${id}`)
}